import { stripCharacterMemoryPrefix } from '../utils/characterMemoryPrefix';

export type ParsedReqCommand = {
  reqMemoryName: string;
  reqOperatorSymbol: string;
  reqValue: string;
  reqOtherwise: string;
  reqHideIndicator: string;
};

export function parseReqCommand(remainder: string): ParsedReqCommand {
  const parts = remainder.split(',').map((p) => p.trim());

  const mainMatch = /^((?:memory\.)?\w+)\s*(=|<>|>=|<=|<|>)\s*(-?(?:memory\.)?\w+)$/i.exec(parts[0]);
  const reqMemoryName = stripCharacterMemoryPrefix(mainMatch?.[1]?.toLocaleLowerCase().trim() ?? '');
  const reqOperatorSymbol = mainMatch?.[2]?.trim() ?? '';
  const reqValue = mainMatch?.[3]?.trim() ?? '';

  const otherwiseRaw = parts[1] ? parts[1].replace(/^otherwise\s+/i, '').trim() : '';
  const reqOtherwise = ['hide', 'disable'].includes(otherwiseRaw.toLowerCase()) ? otherwiseRaw : '';

  const reqHideIndicator = parts[2]?.trim() ?? '';

  return { reqMemoryName, reqOperatorSymbol, reqValue, reqOtherwise, reqHideIndicator };
}
